export const DATA_LINK = 'data-link';
export const PROCESSING_PAYMENT = '__flowgate-processing-payment';
